import { render } from "./TechnicalDocumentationCategory.vue?vue&type=template&id=24b9fed3&ts=true"
import script from "./TechnicalDocumentationCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnicalDocumentationCategory.vue?vue&type=script&setup=true&lang=ts"

import "./TechnicalDocumentationCategory.vue?vue&type=style&index=0&id=24b9fed3&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/regulations/TechnicalDocumentationCategory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24b9fed3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24b9fed3', __exports__)) {
    console.log('reload')
    api.reload('24b9fed3', __exports__)
  }
  
  module.hot.accept("./TechnicalDocumentationCategory.vue?vue&type=template&id=24b9fed3&ts=true", () => {
    console.log('re-render')
    api.rerender('24b9fed3', render)
  })

}


export default __exports__